import type { AnimationDataV8 } from './types/v8';
import type { AnimationDataV9 } from './types/v9';

/**
 * V8 → V9. Pure type widening: `Ingredient` gains an optional `isPreset`
 * flag marking ingredients imported from the video's style preset. Every V8
 * blob is structurally a V9 blob — just bump the version.
 */
export function v8ToV9(input: AnimationDataV8): AnimationDataV9 {
    return { ...input, version: 9 };
}
